module.exports = __webpack_public_path__ + "static/media/iconomeinteresa.e8261efa.svg";